<!--  -->
<template>
  <div id="newDetail">
    <van-loading v-if="loading" />
    <van-nav-bar
      title="详情"
      right-text="集锦"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <main>
      <h3>{{ viewData.title }} </h3>
      <p>活动时间：{{viewData.activityTime}} {{ viewData.beginTime }} -{{ viewData.endTime}} </p>
      <p>活动地点：{{ viewData.address }}</p>
      <div class="content">
        {{ viewData.content }}
      </div>
      <footer>
        <div>
          <h5>参会人员</h5>
          <span @click="toSignIn(viewData)">签到管理></span>
        </div>

        <ul>
          <li
            v-for="(items,inexs) in viewData.democracyUserList"
            :key="inexs"
          >
            <van-badge color="#fff">
              <img
                :src="items.heardImages.length>0?items.heardImages[0].fullUrl:mrImage"
                alt=""
              >

              <!-- <template #content>
                <van-icon
                  v-if="viewData.status == 1"
                  size="15"
                  class-prefix="iconfont icon-qiandaochenggong"
                />
                <van-icon
                  v-if="viewData.status == 0"
                  size="15"
                  class-prefix="iconfont icon-weiqiandao"
                />

              </template> -->
            </van-badge>

            <span>{{ items.name }}</span>
          </li>
        </ul>
      </footer>
    </main>

    <van-button
      type="info"
      class="buttonFixed"
      v-if="viewData.status === 0"
      @click="signIn(viewData)"
      block
    >签 到</van-button>

  </div>
</template>

<script>
import NavBar from '../../compents/header.vue'
import { Toast } from 'vant';
import mrImage from '../../assets/images/mrtx.png'

export default {
  components: {
    NavBar
  },
  data () {
    return {
      currt: 1,
      finished: false,
      mrImage: mrImage,
      viewData: {},
      loading: true
    };
  },
  mounted () {

    this.$post('/api/wl-party-web-manager/democracy/view/' + this.$route.query.id).then(res => {
      this.loading = false
      this.viewData = { ...res.data }
    })
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1);
    },
    onClickRight () {
      this.$router.push({
        path: '/Democratic/jj',
        query: {
          id: this.$route.query.id
        }
      })
    },
    signIn (item) {
      this.$put('/api/wl-party-web-manager/democracy/signing/' + this.$route.query.id).then(res => {
        Toast.success('签到成功');
        this.$post('/api/wl-party-web-manager/democracy/view/' + this.$route.query.id).then(res => {
          this.loading = false
          this.viewData = { ...res.data }
        })
      })
    },
    toSignIn (item) {
      this.$router.push({
        path: '/Democratic/signIn',
        query: {
          id: this.$route.query.id
        }
      })
    }


  }


}

</script>
<style lang='less' scoped>
img {
  width: 100% !important;
}
#newDetail {
  width: 100%;
  height: 100%;
  background: rgb(243, 243, 243);
  .buttonFixed {
    width: 60%;
    position: fixed;
    bottom: 6%;
    left: 20%;
  }
  main {
    width: 100%;
    height: calc(100% - 40px);
    overflow-y: auto;
    padding: 15px 10px;
    background: #fff;

    h3 {
      font-size: 18px;
      background: #fff;
    }
    p {
      padding: 5px 0;
      color: #333;
      background: #fff;
    }
    .content {
      background: #fff;

      padding: 15px 0;
      color: #333;
      font-size: 14px;
      text-indent: 28px;
    }
    footer {
      margin-top: 20px;
      background: #fff;

      div {
        display: flex;
        justify-content: space-between;
        align-content: center;
        padding: 15px 0;
        h5 {
          font-size: 14px;
          color: #333;
        }
        span {
          font-size: 12px;
        }
      }
      ul {
        display: flex;
      }
      li {
        text-align: center;
        padding-right: 20px;
        img {
          width: 23px !important;
          display: block;
          height: 23px;
        }
        span {
          font-size: 12px;
          color: #333;
        }
      }
    }
  }
}
</style>